import type { EmitType } from '@syncfusion/ej2-base';
import type { DateRangePicker, DateRangePickerModel, RangeEventArgs } from '@syncfusion/ej2-calendars';

export async function daterange(appendTo: string, start: Date, end: Date, onchange: EmitType<RangeEventArgs>, options?: DateRangePickerModel): Promise<DateRangePicker> {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-lists/styles/bootstrap4.css');
    await import('@syncfusion/ej2-calendars/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DateRangePicker } = await import('@syncfusion/ej2-calendars');

    const targeTele = document.querySelector(appendTo) as HTMLElement;

    let dateRangePicker: DateRangePicker = (targeTele as any).dateRangePicker;

    if (dateRangePicker) {
        dateRangePicker.destroy();
        delete (targeTele as any).dateRangePicker;
    }

    let opts = {
        placeholder: 'Select a date range',
        startDate: start,
        endDate: end,
        showClearButton: false,
        allowEdit: false,
        change: onchange,
        openOnFocus: true,
        ...(options || {})
    } as DateRangePickerModel;

    dateRangePicker = new DateRangePicker(opts);

    dateRangePicker.appendTo(appendTo);

    (targeTele.nextElementSibling as HTMLElement).ontouchend = (evt) => {
        dateRangePicker.focusIn();
    }

    (targeTele.nextElementSibling as HTMLElement).onclick = (evt) => {
        dateRangePicker.show();
    }

    (targeTele as any).dateRangePicker = dateRangePicker;

    return dateRangePicker;
}
